/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var UIUtil = require('psa-core/util/ui');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');

var ContentServerLinkView = require('common/views/ContentServerLinkView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');
var SideNavSectionView = require('common/views/SideNavSectionView');
var ConfirmationModalView = require('common/views/ConfirmationModalView');

var COCEventDetailsView = require('./COCEventDetailsView');
var COCEventVenueDetailsView = require('./COCEventVenueDetailsView');
var COCEventOrganizationDetailsView = require('./COCEventOrganizationDetailsView');
var COCEventAuditLogView = require('./COCEventAuditLogView');
var CancelEvent = require('../services/CancelEvent');

var tmplCOCEventView = require('../templates/COCEventView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventView,

  className: 'coc-event-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    eventContainer: '.event-container',
    actionsDropdown: '.dropdown-container',
    csLinkContainer: '.cs-link-container'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    eventContainer: '@ui.eventContainer',
    actionsDropdown: '@ui.actionsDropdown',
    csLinkContainer: '@ui.csLinkContainer'
  },

  onBeforeShow: function() {
    var event = this.model.get('event') || {};
    var eventId = event.id;
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            text: 'View Event Details'
          }
        ]
      })
    );

    this.showChildView(
      'csLinkContainer',
      new ContentServerLinkView({
        model: new Backbone.Model({
          buttonText: 'Attachments',
          contentServerId: modelGet(this.model, 'event.csFolderId')
        })
      })
    );

    var dropDownOptions = [];
    dropDownOptions = dropDownOptions.concat([
      {
        text: 'Edit Event Details',
        link: '#coc/event/' + eventId + '/edit'
      },
      {
        text: 'Update Venue Selection',
        link: '#coc/event/' + eventId + '/edit-venue'
      },
      {
        text: 'Update Organization Selection',
        link: '#coc/event/' + eventId + '/edit-org'
      },
      {
        text: 'Cancel Event',
        onClick: this.onClickCancelEvent.bind(this)
      }
    ]);

    this.showChildView(
      'actionsDropdown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Actions',
          options: dropDownOptions
        })
      })
    );

    var sideNavTabs = [
      {
        id: 'eventDetails',
        title: 'Event Details',
        showRequiredFieldDisclaimer: false,
        view: new COCEventDetailsView({
          model: this.model,
          isReadOnly: true
        })
      },
      {
        id: 'venueDetails',
        title: 'Venue Details',
        showRequiredFieldDisclaimer: false,
        view: new COCEventVenueDetailsView({ model: this.model, isReadOnly: true })
      },
      {
        id: 'organizationDetails',
        title: 'Organization Details',
        showRequiredFieldDisclaimer: false,
        view: new COCEventOrganizationDetailsView({ model: this.model, isReadOnly: true })
      },
      {
        id: 'auditLog',
        title: 'Audit Log',
        view: new COCEventAuditLogView({ model: this.model })
      }
    ];

    this.dashboard = new SideNavSectionView({
      collection: new Backbone.Collection(sideNavTabs)
    });

    this.showChildView('eventContainer', this.dashboard);
  },

  onClickCancelEvent: function() {
    var self = this;
    var message =
      'Are you sure you want to cancel this Event?  Doing so will cancel the Outlook event for all participants.  This action cannot be undone.';
    UIUtil.showModal({
      title: 'Cancel Event',
      view: new ConfirmationModalView({
        confirmText: 'Cancel the Event',
        rejectText: 'Close',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var eventId = self.model.get('event').id;
            return CancelEvent({ eventId: eventId });
          },
          onConfirmDone: function() {
            Radio.channel('navigate').trigger('show:int:coc:eventsearch');
          }
        })
      })
    });
  }
});
